export const homeServiceMessages = {
  DEFAULT_ERROR: 'Something went wrong',
};
